import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';

export const QUERY_STORE_ALL = 'STORE_ALL';

export interface StoreResponse {
    id: number;
    shopmanager_id: number;
    address_id: number;
    name: string;
    category: string;
    logo: string;
    latitude: number;
    longitude: number;
    is_open: number;
    description: any;
    type: any;
    phone: any;
    inventory: any;
    created_at: string;
    updated_at: string;
    qr_code: any;
    active: number;
    is_qr_code_required: number;
    fraud_prevention_id: number;
    store_business_type: any;
    store_business_quantity: any;
    hide_zero_stock: number;
    globalTransfers: Array<Record<string, any>>;
}

export enum StoreInventory {
    storePhysical = 'store-physical',
    warehousePhysical = 'warehouse-physical',
    virtual = 'virtual',
}

export interface ParamsGetAllStore {
    orderBy?: string;
    inventory?: keyof typeof StoreInventory;
    preloadPendingGlobalTransfers?: boolean;
}

export function useGetAllStore(
    paramsStore?: ParamsGetAllStore,
    enabled = true,
) {
    const getAllStore = async () => {
        const response = await api.get<StoreResponse[]>('/get-all-stores', {
            params: {
                orderBy: paramsStore?.orderBy || 'name',
                inventory: paramsStore?.inventory
                    ? StoreInventory[paramsStore?.inventory]
                    : undefined,
                preloadPendingGlobalTransfers:
                    paramsStore?.preloadPendingGlobalTransfers,
            } as ParamsGetAllStore,
        });
        return response.data;
    };

    return useQuery([QUERY_STORE_ALL], getAllStore, {
        refetchOnWindowFocus: false,
        enabled: !!enabled,
    });
}
